import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

import { RouterPath } from '@/models/enums'
import { headerSidebarLinks } from '@/router'

export const usePageTitle = () => {
  const location = useLocation()
  const { t } = useTranslation('menu')

  const pageTitle = useMemo(() => {
    const sidebarLinks = headerSidebarLinks(t)
    return sidebarLinks.find((route) => `/${RouterPath.Hub}/${route.to}` === location.pathname)?.children
  }, [location.pathname, t])

  return pageTitle
}
